// Display-helpers shared between the games list (cards + filter
// dropdowns) and the game detail page.

export function genderLabel(gender: string | null | undefined): string | null {
  if (!gender) return null;
  switch (gender.toLowerCase()) {
    case "boys": return "Boys";
    case "girls": return "Girls";
    case "coed":
    case "co-ed": return "Co-Ed";
    default: return gender;
  }
}

// All known gender values in the order we want to render them in
// dropdowns. Lowercase to match what the iPad uploads.
export const ALL_GENDERS = ["boys", "girls", "coed"] as const;
